export default __webpack_public_path__ + "static/media/trustedby1.9e98278a.svg";